import { useEffect } from "react";
import { useHistory } from "react-router-dom"
function EmptyPage() {
    const history = useHistory();
    useEffect(() => {
        history.push(`/${window.location.pathname.split("/")[2]}`)
    }, [])
  return (
    <> 
    </>
  )
}

export default EmptyPage
